import {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import * as identify from "@arcgis/core/rest/identify.js";
import IdentifyParameters from "@arcgis/core/rest/support/IdentifyParameters.js";
import {Empty} from "antd";
import MapImageLayersInfoResultsComponent from "./MapImageLayersInfoResultsComponent";
import { getProxiedUrl } from "../../../../utilities/MapUtilities";


const MapImageLayersInfoComponent = forwardRef(({mapUtilities, mapView, table, mapImageLayers,
                                                    resultTabItems, setResultTabItems, event,
                                                    setGeometry, setGeometryType}, ref) => {

    const [hasResults, setHasResults] = useState(false);
    const [currentTabsResult, setCurrenTabsResult] = useState({});

    useImperativeHandle(ref, () => ({
        getCurrentTabResult() {
            return currentTabsResult;
        }
    }));

    let tabResults = {};
    const renderResults = (results, mapLayer, sublayer) => {
        tabResults[mapLayer.name + ": " + sublayer.title] = results[0];
        setCurrenTabsResult(tabResults);

        return <MapImageLayersInfoResultsComponent mapUtilities={mapUtilities} mapView={mapView} table={table} results={results} mapLayer={mapLayer}
                                                   sublayer={sublayer} setGeometry={setGeometry}
                                                   setGeometryType={setGeometryType}
                                                   currentTabsResult={tabResults}
                                                   setCurrenTabsResult={setCurrenTabsResult}
        />
    };

    useEffect(() => {
        var items = [...resultTabItems];
        let requestToComplet = mapImageLayers.length;
        let TOLERANCE = 10;

        mapImageLayers.map(function (mapImageLayer, i) {

            let mapLayerView = mapUtilities.getMapLayerView(mapImageLayer.sgvmapMapLayer.name, false)
            const sublayers = [];
            for (var i in mapLayerView.layer.sublayers._items) {
                if (mapLayerView.layer.sublayers._items[i].visible) {
                    sublayers.push(mapLayerView.layer.sublayers._items[i].id)
                }
            }

            let params = new IdentifyParameters();
            params.returnGeometry = true;
            params.tolerance = TOLERANCE;
            params.layerIds = sublayers;
            params.width = mapView.width;
            params.height = mapView.height;
            params.geometry = event.mapPoint;
            params.mapExtent = mapView.extent;
            params.layerOption = "visible"; //Possible Values:"top"|"visible"|"all"|"popup"

            var hasResultsCopy = false;
            if (sublayers.length > 0) {
                // Usar URL con proxy en desarrollo
                const identifyUrl = getProxiedUrl(mapImageLayer.sgvmapMapLayer.conf.url);
                console.log(`[MapImageLayersInfoComponent] Usando URL para identify: ${identifyUrl}`);
               
                identify.identify(identifyUrl, params)
                    .then(function (response) {
                        --requestToComplet;
                        var resultsAux = {}                       
                        for (var i in response.results) {
                            setHasResults(true);
                            var result = response.results[i];
                            if (!resultsAux[result.layerId]) resultsAux[result.layerId] = [];
                            resultsAux[result.layerId].push(result);
                            console.log('resultado', result.feature.attributes)
                        }


                        for (var key in resultsAux) {
                            for (var j in mapImageLayer.sgvmapMapLayer.conf.sublayers) {
                                var sublayer = mapImageLayer.sgvmapMapLayer.conf.sublayers[j];
                                if (sublayer.id == key) {
                                    var item = {
                                        key: mapImageLayer.sgvmapMapLayer.name + ": " + sublayer.title,
                                        label: sublayer.title,
                                        children: renderResults(resultsAux[key], mapImageLayer.sgvmapMapLayer, sublayer),
                                        geometry: resultsAux[key][0].feature.geometry,
                                        geometryTye: resultsAux[key][0].feature.geometry.type
                                    };

                                    var found = items.some(i => i.key == item.key)
                                    if (!found) {
                                        items.push(item);
                                    }
                                }
                            }
                        }
                        if (requestToComplet == 0) {
                            console.log("items", items)
                            setResultTabItems(items);
                        }
                    });
            } else {
                --requestToComplet;
            }

        })
    }, [])

    return (
        <>
            {!hasResults && <Empty/>}
        </>
    );
})

export default MapImageLayersInfoComponent;